module.exports = __webpack_public_path__ + "static/media/cover-login-access-5.acd9c599.jpg";